
import { ReactComponent as WarningIndicator } from '@/assets/svgs/warning-indicator.svg';
import Button from '@/components/Button';
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import rem from '@/utils/rem.js';

const Toast = ({ errorMessage, close, show, title = "Event Details", warningIcon = false }) => {
	return (
		<>
			<Modal visible={show} variant='medium' close={close}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										{warningIcon &&
											<WarningIndicator />
										}
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{title}
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							{errorMessage}
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button ghost text="Close"
								submit={() => {
									close()
								}}
							/>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>
		</>
	)
}

export default Toast
